import { CSSProperties } from "react";
import styled from "styled-components";

export const buttonStyle = {
  display: "flex", // Habilita o uso de Flexbox
  justifyContent: "center", // Centraliza o texto horizontalmente
  alignItems: "center", // Centraliza o texto verticalmente
  width: "550px", // Ajuste de largura
  fontSize: "28px", // Tamanho da fonte
  padding: "22px 40px", // Aumento no tamanho vertical do botão
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};

export const formStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  border: "3px solid black",
  margin: "15px",
  background: "#f0f4f7",
  borderRadius: "10px",
};

export const btnStyle: CSSProperties = {
  marginTop: 20,
  borderWidth: "3px",
  borderRadius: "12px",
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};

export const ContainerModal = styled.div`
  width: 100%;
  height: auto;
  margin-top: 18px;
  border: 2px solid #858986;
  background: rgb(0, 54, 68);
  border-radius: 5px;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
`;
export const ContainerModalBtn = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
`;
export const ContainerModalArquivo = styled.div`
  margin: 15px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 3px solid black;
  border-radius: 10px;
  background-color: #f0f4f7;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;
export const TitleIndex = styled.h1`
  font-size: 35px;
  font-weight: bold;
  color: rgb(0, 54, 68);
  margin-left: 15px;
`;
export const TitleModal = styled.h1`
  font-size: 25px;
  font-weight: bold;
  color: #ffffff;
  margin-left: 15px;
`;
export const TextModal = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #3a3a3a;
  margin-left: 15px;
`;
export const AlertTextModal = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin-left: 15px;
`;

export const CheckBoxContainer = styled.div`
  width: 350px;
  height: auto;
  margin-left: 80px;
`;
